/* eslint-disable array-bracket-newline, indent */
import { useEffect, useState } from 'react';
import { StorageKeys } from '../../../../helpers/localStorage';

export interface ISideBarWallet {
  address: string;
  amount: number;
  nativeToken: string;
  logo: string;
  nickname: string;
  chain: string;
}

const useWalletSelect = (
  address: string,
  amount: number,
  nativeToken: string,
  chain: string,
  logo?: string,
  nickname?: string
) => {
  const [previousWallets, setPreviousWallets] = useState<ISideBarWallet[]>([]);

  useEffect(() => {
    const savedWallets: ISideBarWallet[] = JSON.parse(
      localStorage.getItem(StorageKeys.previous_wallets) || '[]'
    ).filter((item: ISideBarWallet) => item.address !== address);
    setPreviousWallets(savedWallets);

    if (logo && nickname) {
      const currentWallet = {
        address,
        amount,
        nativeToken,
        logo,
        nickname,
        chain,
      };
      const newWallets = [currentWallet, ...savedWallets];

      localStorage.setItem(
        StorageKeys.previous_wallets,
        JSON.stringify(newWallets)
      );
    }
  }, [address, amount, nativeToken, logo, nickname, chain]);

  return previousWallets;
};

export default useWalletSelect;
